module.exports = {"protocol":"https","api":{"host":"aqvsun0ryj.execute-api.us-east-1.amazonaws.com/default"}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 432
// module chunks = 0